import QuestionForm from "../component/QuestionForm";
const AddNewQuestion = () => { return (<QuestionForm />) }
export default AddNewQuestion;